<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="M13 19c0-.34.04-.67.09-1H4V8l8 5l8-5v5.09c.72.12 1.39.37 2 .72V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.09c-.05-.33-.09-.66-.09-1m7-13l-8 5l-8-5h16m0 9v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"/></svg>
</template>

<script>
    export default {
        name: "EmailAddIcon"
    }
</script>

<style scoped>

</style>